<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center"
          ><span style="color: #0081c7">{{ fields.title }}</span
          ><v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn></v-card-title
        >
      </div>
      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <label class="label-input">Section Name</label>
        <v-row
          ><v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name"/></v-col
          ><v-col cols="12" md="4"><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor"/></v-col
        ></v-row>
        <label class="label-input">Header</label>
        <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />
        <div class="mt-6 group-item">
          <v-row class="mb-2">
            <v-col cols="12" md="4">
              <ColorPicker
                v-model="fields.cardBorderColor"
                name="tryher-card-compare-border"
                label="Card Border"
                default-color="#FF6099"
              />
            </v-col>
            <v-col cols="12" md="4">
              <ColorPicker
                v-model="fields.cardTextColor"
                name="tryher-card-compare-text"
                label="Card Text"
                default-color="#000000"
              />
            </v-col>
            <v-col cols="12" md="4">
              <ColorPicker
                v-model="fields.cardBackgroundColor"
                name="tryher-card-compare-background"
                label="Card Background"
                default-color="#FFFFFF"
              />
            </v-col>
          </v-row>
          <v-select v-model="fields.badPosition" :items="badPositionOptions" label="Bad side position" />
          <v-text-field v-model="fields.vsText" label="VS text" />
          <v-row
            ><v-col cols="12" md="6"
              ><label>✅ Good image</label>
              <UploadImage
                :image="{ imageSrc: fields.goodImage }"
                :height="'200'"
                :typeUpload="'image'"
                @callback="obj => (fields.goodImage = obj.imageSrc)"
                @callbackDelete="() => (fields.goodImage = '')"
              /> </v-col
            ><v-col cols="12" md="6"
              ><label>❌ Bad image</label>
              <UploadImage
                :image="{ imageSrc: fields.badImage }"
                :height="'200'"
                :typeUpload="'image'"
                @callback="obj => (fields.badImage = obj.imageSrc)"
                @callbackDelete="() => (fields.badImage = '')"
              /> </v-col
          ></v-row>
          <div class="d-flex justify-space-between align-center mt-5">
            <label class="label-input mb-0">Comparison rows</label
            ><v-btn small color="primary" @click="handleAddItem"><v-icon size="16">mdi-plus</v-icon>Add row</v-btn>
          </div>
          <v-expansion-panels accordion class="mt-3">
            <v-expansion-panel v-for="(item, index) in fields.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <div class="d-flex align-center" style="gap: 4px; overflow: hidden;">
                    <v-chip small color="green" text-color="white">{{ item.good || 'Good' }}</v-chip>
                    <span class="grey--text">vs</span>
                    <v-chip small color="grey lighten-2">{{ item.bad || 'Bad' }}</v-chip>
                  </div>
                  <v-btn icon @click.stop="handleRemoveItem(index)"><v-icon color="#ff6c6c">mdi-delete</v-icon> </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field v-model="item.good" label="✅ Good"/>
                <v-text-field v-model="item.bad" label="❌ Bad"/></v-expansion-panel-content></v-expansion-panel
          ></v-expansion-panels>
        </div>
        <SectionSettingsContainerFuild
          class="mt-6"
          :settings="fields.settings"
          :containerPage="fields.containerPage"
          :showBackgroundImage="false"
          :showContainerPage="false"
        />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions
          ><v-spacer /><v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn
          ><v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn></v-card-actions
        >
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultItem = () => ({
  good: 'Good comparison point',
  bad: 'Bad comparison point',
});
export default {
  name: 'TryherCardCompare',
  components: { UploadImage, ColorPicker, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      badPositionOptions: [
        { text: 'Right', value: 'right' },
        { text: 'Left', value: 'left' },
      ],
      fields: {
        title: 'Tryher card compare',
        enableAnchor: false,
        header: '',
        goodImage: '',
        badImage: '',
        vsText: 'VS',
        badPosition: 'right',
        cardBorderColor: '#FF6099',
        cardTextColor: '#000000',
        cardBackgroundColor: '#FFFFFF',
        listItem: [],
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFF7FC',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
      },
    };
  },
  mounted() {
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...this.fields,
      ...extract,
      settings: { ...this.fields.settings, ...(extract.settings || {}) },
      containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
      listItem: (extract.listItem || []).map(item => ({ ...defaultItem(), ...item })),
    };
  },
  methods: {
    handleAddItem() {
      this.fields.listItem.push(defaultItem());
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionTryherCardCompare(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}

.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}

.header-modal {
  top: 0;
}

.footer-modal {
  bottom: 0;
}
</style>
